module.exports = __webpack_public_path__ + "static/img/kitty.cf5fe8e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kitty.jpg
// module id = 164
// module chunks = 0